var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMatch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "convertshape-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16667 13.4583V15.7083C9.16667 17.5833 8.41667 18.3333 6.54167 18.3333H4.29167C2.41667 18.3333 1.66667 17.5833 1.66667 15.7083V13.4583C1.66667 11.5833 2.41667 10.8333 4.29167 10.8333H6.54167C8.41667 10.8333 9.16667 11.5833 9.16667 13.4583Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3333 12.5C18.3333 15.725 15.725 18.3333 12.5 18.3333L13.375 16.875",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.66667 7.5C1.66667 4.275 4.275 1.66667 7.5 1.66667L6.625 3.125",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.5833 9.16667C16.6544 9.16667 18.3333 7.48773 18.3333 5.41667C18.3333 3.3456 16.6544 1.66667 14.5833 1.66667C12.5123 1.66667 10.8333 3.3456 10.8333 5.41667C10.8333 7.48773 12.5123 9.16667 14.5833 9.16667Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMatch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/match.01fa950d9391e26b4cb5d1f30d8ffa80.svg";